import PropTypes from 'prop-types';
import styled from 'styled-components';
import { font, palette } from 'styled-theme';

const Label = styled.label`
  font-family: ${font('primary')};
  color: ${palette('grayscale', 1)};
  font-size: 1rem;
  line-height: 2em;
`;
Label.displayName = 'Label';
Label.propTypes = {
  reverse: PropTypes.bool,
};

export default Label;



// WEBPACK FOOTER //
// ./src/shared-components/atoms/Label/index.js